// Module
var code = "<span class=\"secondary\">{{newItem.addNewText}}</span><span title=\"{{newItem.id}}\">{{newItem.name}}</span>";
// Exports
export default code;